import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  basicInfo: {
    applicationName: '',
    domain: '',
    description: '',
    organization: '',
    deploymentEnvironment: '',
    dataSensitivity: [],
    autonomyLevel: [],
    modifiers: [],
    riskContextNotes: '',
  },
  technicalDetails: {
    interfaceType: '',
    llmProvider: '',
    llmModel: '',
    frontendStack: '',
    backendStack: '',
    apiEndpoints: [],
    ragEmbedding: '',
    ragVector: '',
    ragRetrieval: '',
    authMethod: '',
    authToken: '',
    aiUrl: '',
    uiInputSelector: '',
    uiOutputSelector: '',
    integrationTools: [],
    logsApi: '',
    agentEnabled: false,
    agentFramework: '',
    agentType: '',
    agentPlanner: '',
    agentMemory: '',
    agentTools: [],
    customAgentTool: '',
    agentEmbedding: '',
    agentVector: '',
    agentRetrieval: '',
    agentAuthMethod: '',
    agentAuthToken: '',
    agentUrl: '',
    agentInputSelector: '',
    agentOutputSelector: '',
  },
  useCaseCatalog: {
    useCaseTitle: '',
    seriousness: '',
    useCaseDescription: '',
    expectedBehavior: '',
    dataSource: '',
    smeOwner: '',
    riskAssociation: [],
    evaluationScope: [],
  },
  useCasesList: [],
  classificationResult: null,
  currentStep: 0,
  loading: false,
  error: null,
};

const applicationSetupSlice = createSlice({
  name: 'applicationSetup',
  initialState,
  reducers: {
    setBasicInfo: (state, action) => {
      state.basicInfo = { ...state.basicInfo, ...action.payload };
    },
    setTechnicalDetails: (state, action) => {
      state.technicalDetails = { ...state.technicalDetails, ...action.payload };
    },
    setUseCaseCatalog: (state, action) => {
      state.useCaseCatalog = { ...state.useCaseCatalog, ...action.payload };
    },
    setUseCasesList: (state, action) => {
      state.useCasesList = action.payload;
    },
    addUseCase: (state, action) => {
      state.useCasesList.push(action.payload);
    },
    removeUseCase: (state, action) => {
      state.useCasesList = state.useCasesList.filter((_, index) => index !== action.payload);
    },
    setClassificationResult: (state, action) => {
      state.classificationResult = action.payload;
    },
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },
    setApplicationSetupData: (state, action) => {
      return { ...state, ...action.payload, loading: false, error: null };
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    resetApplicationSetup: () => initialState,
  },
});

export const {
  setBasicInfo,
  setTechnicalDetails,
  setUseCaseCatalog,
  setUseCasesList,
  addUseCase,
  removeUseCase,
  setClassificationResult,
  setCurrentStep,
  setApplicationSetupData,
  setLoading,
  setError,
  resetApplicationSetup,
} = applicationSetupSlice.actions;

export default applicationSetupSlice.reducer;
